module.exports = __webpack_public_path__ + "img/icon-paper-fail.3c605a50.svg";